import React, { Component } from 'react'
import AppAlertDiv from '../../components/Common/AppAlertDiv'
import { appleStoreUrl, playStoreUrl } from '../../lib/utils'
import InsightCards from '../../components/Common/InsightCards'

export default class insights extends Component {
    render() {
        return (
            <div>
                <h2>Insights
                </h2>
                <hr className='separator' />
                <br />
                <InsightCards />
                {/* <h3>Coming Soon.</h3> */}
                {/* <AppAlertDiv isHtml={true}
                    message={`<p>Saved Insights are available on our mobile apps (<a href=${appleStoreUrl}
                            target='_blank' rel="noopener noreferrer">iOS</a> or <a href=${playStoreUrl}
                               target='_blank' rel="noopener noreferrer">Android</a>) for now and will be available on web soon.`} showIcon /> */}

            </div>
        )
    }
}
